if (!customElements.get('jb-service-presentation')) {
  class JBServicePresentation extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.jobs = new Map();
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.controller.signal };
      this.discover = this.querySelector('.jb-discover');
      this.services = [...this.querySelectorAll('.jb-service-button')];
      this.triggers = [...(this.discover ? [this.discover] : []), ...this.services];
      this.discover?.addEventListener('click', () => this.setOpen(this.discover, this.discover.getAttribute('aria-expanded') !== 'true'), options);
      this.services.forEach(button => button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        this.services.forEach(other => {
          const expanded = other === button && open;
          if (other.getAttribute('aria-expanded') !== String(expanded)) this.setOpen(other, expanded);
        });
      }, options));
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const active = this.triggers.find(button => {
          const panel = this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
          return button.getAttribute('aria-expanded') === 'true' && (button.contains(document.activeElement) || panel?.contains(document.activeElement));
        });
        if (active) { this.setOpen(active, false); active.focus({ preventScroll: true }); }
      }, options);
    }
    setOpen(button, open) {
      const panel = this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
      if (!panel) return;
      const content = panel.querySelector('p');
      const start = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      const previous = this.jobs.get(panel);
      if (previous) { clearTimeout(previous.timer); cancelAnimationFrame(previous.frame); }
      button.setAttribute('aria-expanded', String(open));
      if (this.reduced.matches) {
        panel.hidden = !open;
        panel.style.height = '';
        content.style.opacity = '';
        content.style.transform = '';
        this.jobs.delete(panel);
        return;
      }
      panel.hidden = false;
      panel.style.transition = 'none';
      panel.style.height = start + 'px';
      content.style.transition = 'none';
      content.style.opacity = open ? '0' : '1';
      content.style.transform = open ? 'translateY(8px)' : 'translateY(0px)';
      const end = open ? panel.scrollHeight : 0;
      void panel.offsetHeight;
      const job = { frame: null, timer: null };
      this.jobs.set(panel, job);
      job.frame = requestAnimationFrame(() => {
        if (this.jobs.get(panel) !== job) return;
        panel.style.transition = 'height 420ms cubic-bezier(.22,.72,.25,1)';
        const delay = open ? 60 : 0;
        content.style.transition = 'opacity 260ms ease ' + delay + 'ms, transform 260ms cubic-bezier(.22,.72,.25,1) ' + delay + 'ms';
        panel.style.height = end + 'px';
        content.style.opacity = open ? '1' : '0';
        content.style.transform = open ? 'translateY(0px)' : 'translateY(4px)';
        job.timer = setTimeout(() => {
          if (this.jobs.get(panel) !== job) return;
          panel.hidden = !open;
          panel.style.height = '';
          panel.style.transition = '';
          content.style.transition = '';
          content.style.opacity = '';
          content.style.transform = '';
          this.jobs.delete(panel);
        }, 460);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.jobs?.forEach((job, panel) => {
        clearTimeout(job.timer);
        cancelAnimationFrame(job.frame);
        const button = this.triggers.find(item => item.getAttribute('aria-controls') === panel.id);
        panel.hidden = button?.getAttribute('aria-expanded') !== 'true';
        panel.style.height = '';
        panel.style.transition = '';
        const content = panel.querySelector('p');
        content.style.transition = '';
        content.style.opacity = '';
        content.style.transform = '';
      });
      this.jobs?.clear();
    }
  }
  customElements.define('jb-service-presentation', JBServicePresentation);
}
